import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import ProductDetailsInfo from './info';
import ProductDetailsImage from './image';
import { sendAnalyticsEvent } from '../../../utils/analytics';
import {map} from 'lodash';
import classNames from 'classnames';

const PRODUCT_INFO_ID = 'product-details-information';
const getSliderProps = ({ images }) => {
  const showDots = images.length > 1 ? true : false;

  return {
    className: 'product-images',
    dots: showDots,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    initialSlide: 0,
    arrows: false,
    centerPadding: '30px',
    centerMode: true,
    draggable: true,
    variableWidth: true,
    lazyLoad: false,
    speed: 500,
    touchThreshold: 30,
    touchMove: false,
    swipe: true,

    setPosition() {
      window.dispatchEvent(new Event('resize'));
    },
    afterChange() {
      sendAnalyticsEvent('Shopping', 'Product Detail Image Swipe');
    }
  };
};

export default function ProductDetailsHorizontalScrollImages(props) {
  const { images } = props.product;
  const isSingleImage = images.length === 1 ? true : false;
  const wrapperClasses = classNames('carousel-text-wrapper', { 'single-image': isSingleImage });

  return (
    <div className={wrapperClasses} >
      {isSingleImage &&
        <ProductDetailsImage
          imageURL={images[0].url}
          displayOrder={images[0].display_order}
          key={images[0].id}
          isInCarousel
        />
      }
      {!isSingleImage &&
        <Slider {...getSliderProps({ images })}>
          {
            map(images, ({ id, url, display_order }) => (
              <ProductDetailsImage
                imageURL={url}
                displayOrder={display_order}
                key={id}
                isInCarousel
              />
            ))
          }
        </Slider>
      }
      <ProductDetailsInfo {...props} id={PRODUCT_INFO_ID} />
    </div>
  );
}

ProductDetailsHorizontalScrollImages.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    brand: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string
    }),
    name: PropTypes.string.isRequired,
    product_url: PropTypes.string.isRequired,
    offer: PropTypes.shape({
      currency: PropTypes.string,
      price: PropTypes.number,
      sale_price: PropTypes.number,
      retailer: PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string
      })
    }),
    images: PropTypes.array,
    description: PropTypes.string.isRequired,
    is_sponsored: PropTypes.bool,
    click_tracker: PropTypes.string,
    impression_tracker: PropTypes.string,
    entries: PropTypes.arrayOf(PropTypes.shape({
      truncated_short_title_80: PropTypes.string,
      url: PropTypes.string,
      label: PropTypes.string
    }))
  }),
  meta_data: PropTypes.shape({
    meta_title: PropTypes.string,
    meta_description: PropTypes.string
  }),
  analytics: PropTypes.shape({
    url_full: PropTypes.string
  })
};
